requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('cart.js', () => {
      if (!customElements.get('product-form')) {
        class ProductForm extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.form = this.querySelector('form');
            this.productInfo = this.closest('product-info');
            this.recipientFieldsInputs = this.productInfo?.querySelectorAll('.js-personalized-fields input, textarea');
            this.variantSelectsOrRadios = this.dataset.productType === 'card' ? this.querySelector('variant-selects, variant-radios') : document.getElementById(`variant-radios-${this.dataset.sectionId}`);

            if (this.form) {
              this.form.querySelector('[name=id]').disabled = false;
              this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
              this.addEventListener('change', (e) => {
                if (e.target && e.target.name === 'selling_plan') {
                  this.toggleAddButton(false);
                  this.productInfo?.querySelector('.product__price .price')?.classList.add('price--preorder');
                }
              });
            }

            this.findElements();
            this.initAnimatedButton();
            this.initMediaControlButtons();

            scriptController.scripts.push('product-form.js');
          }

          initMediaControlButtons() {
            this.mediaControlButtonsWrapper = this.querySelector('.card__media-control-buttons');

            if (!this.mediaControlButtonsWrapper) return;

            this.mediaControlButtons = this.mediaControlButtonsWrapper.querySelectorAll('button');

            this.mediaControlButtons.forEach(button => {
              button.addEventListener('click', () => {
                this.media = this.media || this.querySelector('.media');
                this.images = Array.from(this.media.querySelectorAll('img, template'));
                this.currentImageIndex ??= (this.media.classList.contains('media--hover-effect') ? 1 : 0);

                if (button === this.mediaControlButtons[0]) {
                  this.currentImageIndex = Math.max(0, this.currentImageIndex - 1);
                } else {
                  this.currentImageIndex = Math.min(this.images.length - 1, this.currentImageIndex + 1);
                }

                this.mediaControlButtons[0].toggleAttribute('disabled', this.currentImageIndex === 0);
                this.mediaControlButtons[1].toggleAttribute('disabled', this.currentImageIndex === this.images.length - 1);

                let current = this.images[this.currentImageIndex];
                if (current.tagName === 'TEMPLATE') {
                  const img = current.content.cloneNode(true).querySelector('img');
                  current.replaceWith(img);
                  this.images = Array.from(this.media.querySelectorAll('img, template'));
                  current = this.images[this.currentImageIndex];
                }

                this.images.forEach((image, index) => image.classList.toggle('hidden', index !== this.currentImageIndex));
                this.media.classList.remove('media--hover-effect');
                this.classList.add('media-control-buttons--active');
              });

              this.mediaControlButtonsWrapper.addEventListener('mouseenter', () => {
                this.classList.add('media-control-buttons--active');
              });

              this.mediaControlButtonsWrapper.addEventListener('mouseleave', () => {
                setTimeout(() => {
                  this.classList.remove('media-control-buttons--active');
                }, 200);
              });
            });
          }


          findElements() {
            this.quickAddModal = this.closest('quick-add-modal');
            this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
            [this.submitButton] = this.submitButtons;
          }

          toggleAddButton(disable = true, text, modifyClass = true, isSoldOut) {
            if (!this.form) return;
            const addButton = this.form.querySelector('[name="add"]');
            const addButtonText = this.form.querySelector('[name="add"] > span');
            let status = '';

            if (!addButton) return;

            if (disable) {
              addButton.setAttribute('disabled', 'disabled');
              if (text) addButtonText.innerHTML = text;
              status = 'disabled';
            } else {
              const isPreorder = this.form.querySelector('[name="selling_plan"]:checked') ||
                (window.themeSettings.preOrder && this.variantSelectsOrRadios?.getVariantData().inventory[this.variantSelectsOrRadios.currentVariant.id].quantity <= 0 && this.variantSelectsOrRadios?.currentVariant.available) ?
                true :
                false;

              addButton.removeAttribute('disabled');
              addButtonText.innerHTML = isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
              status = isPreorder ? 'preorder' : 'add';
            }

            if (isSoldOut !== undefined) {
              if (isSoldOut) {
                addButton.classList.add('button--sold-out');
                status = 'sold-out';
              } else {
                addButton.classList.remove('button--sold-out');
              }
            }

            addButton.setAttribute('data-status', status);

            if (this.dataset.productType !== 'card') {
              const productFootbarForm = document.getElementById(`product-form-${this.dataset.sectionId}-footbar`);
              if (!productFootbarForm) return;
              const footbarAddButton = productFootbarForm.querySelector('[name="add"]');
              const footbarAddButtonText = productFootbarForm.querySelector('[name="add"] > span');
              let status = '';

              if (disable) {
                footbarAddButton.setAttribute('disabled', 'disabled');
                if (text) footbarAddButtonText.innerHTML = text;
                status = 'disabled';
              } else {
                const isPreorder = this.form.querySelector('[name="selling_plan"]:checked') ||
                  (window.themeSettings.preOrder && this.variantSelectsOrRadios?.getVariantData().inventory[this.variantSelectsOrRadios.currentVariant.id].quantity <= 0 && this.variantSelectsOrRadios?.currentVariant.available) ?
                  true :
                  false;

                footbarAddButton.removeAttribute('disabled');
                footbarAddButtonText.innerHTML = isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
                status = isPreorder ? 'preorder' : 'add';
              }

              footbarAddButton.setAttribute('data-status', status);
            }

            if (!modifyClass) return;
          }

          initAnimatedButton() {
            this.animatedButton = this.querySelector('.js-animated-product-button');

            if (!this.animatedButton) return;

            this.animatedButtonTimeout = 2000;
            this.animatedButtonInterval = setTimeout(() => this.animateButton(this.animatedButton), this.animatedButtonTimeout);
          }

          animateButton() {
            this.animatedButton.addEventListener('animationend', () => {
              this.animatedButton.classList.remove('button--css-animate');
              setTimeout(() => {
                this.animateButton(this.animatedButton);
              }, this.animatedButtonTimeout);
            }, {
              once: true
            });
            this.animatedButton.classList.add('button--css-animate');
          }

          onSubmitHandler(event, callback, enableEventCall = true) {
            event.preventDefault();
            this.clearPersonalizedFieldsErrors();

            const personalizedFieldsErrors = this.validatePersonalizedFields();

            if (personalizedFieldsErrors.length) {
              this.onError(personalizedFieldsErrors);
              return;
            }

            event.target.focus();
            this.findElements();

            const isSubmitButtonLoading = this.submitButtons?.some(button => button.classList.contains('loading'));
            if (isSubmitButtonLoading) return;

            this.onError();
            cartBase.addToCart({
              body: new FormData(this.form),
              target: this,
              onLoadingToggle: (isLoading) => {
                this.toggleProductLoading({
                  isLoading,
                  processForm: false
                });
                cartBase.toggleCartLoading({
                  isLoading
                });

                if (!isLoading) {
                  this.quickAddModal?.hide(true);

                  if (callback) callback();
                }
              },
              enableEventCall
            });
          }

          clearPersonalizedFieldsErrors() {
            if (!this.recipientFieldsInputs) return;

            this.recipientFieldsInputs.forEach(element => {
              element.classList.remove('error');
            });
          }

          validatePersonalizedFields() {
            const errors = [];

            if (this.recipientFieldsInputs) {
              this.recipientFieldsInputs.forEach(element => {
                if (element.hasAttribute('required') && element.value.trim() === '') {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.emptyFieldError) == -1) {
                    errors.push(window.cartStrings.emptyFieldError);
                  }
                }

                if (element.getAttribute('maxlength') && element.value.length > parseInt(element.getAttribute('maxlength'))) {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.maxLengthError) == -1) {
                    errors.push(window.cartStrings.maxLengthError.replace(
                      '{{ value }}',
                      element.getAttribute('maxlength')));
                  }
                }
              });
            }

            return errors;
          }

          toggleProductLoading({
            isLoading,
            processForm = true,
            processButton = true
          }) {
            this.findElements();

            if (processButton && this.submitButtons?.length) {
              this.submitButtons.forEach(button => {
                button.toggleAttribute('aria-disabled', isLoading);
                button.classList.toggle('loading', isLoading);
              });
            }

            if (processForm) {
              this.classList.toggle('product-form--loading', isLoading);
            }
          }

          onError(errors) {
            this.querySelector('error-messages')?.show(errors);
            document.querySelector('push-messages')?.push(errors);
          }

          disconnectedCallback() {
            if (this.animatedButtonInterval) clearInterval(this.animatedButtonInterval);
          }
        }

        customElements.define('product-form', ProductForm);
      }
    });
  });
});